import { Trans } from '@lingui/react'
import { shape, string } from 'prop-types'
import { connectStateResults } from 'react-instantsearch-dom'

import { SearchInformationModal } from 'views/components/organisms/SearchInformationModal'

import './FilterBox.scss'

const FilterBox = props => {
  const { nbHits: total } = props.searchResults || {}

  return (
    <div className="e-FilterBox u-position--relative">
      <ul className="l-flex l-flex--wrap a-list-reset">
        <li>
          <span
            className="u-font-weight--bold u-color--grey e-FilterBox__title"
            data-qa-id="search-result-result-counter"
            suppressHydrationWarning
          >
            <Trans
              id="searchResults.label.totalResultsNumber"
              values={{ total }}
            />
          </span>
          <SearchInformationModal />
        </li>
      </ul>
    </div>
  )
}

FilterBox.propTypes = {
  searchResults: shape({}),
  indexName: string.isRequired,
}

FilterBox.defaultProps = {
  searchResults: null,
}

export default connectStateResults(FilterBox)
